export default __webpack_public_path__ + "static/mstile-310x310-2f6982ea81b1913bf1ac87ccbf303a71.png";